export const selectUserState = state => state.userState;
export const selectDocsVersion = state => state.userState.docsVersion;
export const selectHasInitializedDocVersion = state => state.userState.hasInitializedDocVersion;
export const selectLoggedIn = state => state.userState.loggedIn;
export const selectUserGates = state => state.userState.userGates;